import {createSelector} from 'reselect';

const searchInputValueSelector = state => state.searchInputValue;

export const getSearchInputValue = createSelector(
  searchInputValueSelector,
  searchInputValue => searchInputValue
);
